import styled from '@emotion/styled';

const baseTextareaPadding = 10;
const submitBtnSize = 38;
const buttonsSpacing = 10;

// Buttons now sit in a bottom row; only the send button (rightmost) needs right clearance.
export const editorPaddingRight = baseTextareaPadding + submitBtnSize + buttonsSpacing;

export const uploadButtonHeight = 40;

export const EditorWrapper = styled('div')(({ theme }) => ({
  boxSizing: 'border-box',
  position: 'relative',
  backgroundColor: theme.palette.white.main,
  borderRadius: 5,
  border: `2px solid ${theme.palette.gray.light2}`,
  outline: 'none',
  resize: 'none',
  padding: baseTextareaPadding,
  paddingRight: editorPaddingRight,
  paddingBottom: baseTextareaPadding + uploadButtonHeight,
  width: '100%',

  fontFamily: theme.fonts.regular,
  fontSize: 16,
  color: theme.palette.black.light1,
  transition: 'border 0.3s',

  '&:hover': {
    border: `2px solid ${theme.palette.primary.main}`,
  },

  '&:focus-within': {
    border: `2px solid ${theme.palette.primary.main}`,
  },

  '& .ProseMirror, & .remirror-editor.ProseMirror': {
    outline: 'none',
    minHeight: 66,
    maxHeight: 390,
    overflowY: 'auto',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',

    [`@media (max-width: ${theme.breakpoints.values.chatCompactLayout}px)`]: {
      minHeight: 50,
    },

    '& p': {
      margin: 0,
    },

    '& .remirror-is-empty:first-of-type::before': {
      content: 'attr(data-placeholder)',
      color: theme.palette.gray.main,
      pointerEvents: 'none',
      position: 'absolute',
    },

    '& .remirror-mention-atom': {
      fontFamily: theme.fonts.semiBold,
      color: theme.palette.primary.main,
    },
  },
}));
